import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginPage from './pages/LoginPage';
import MainApp from './pages/MainApp';
import CustomerSelfServicePage from './pages/CustomerSelfServicePage';
import AdminRoutes from './pages/admin/AdminRoutes';
import { useAuthStore } from './store';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <>{children}</> : <Navigate to='/login' />;
};

// ─── Store CRM app (served under /crm) ───────────────────────────
function CrmRoutes() {
  return (
    <Routes>
      <Route path='/login' element={<LoginPage />} />
      <Route path='/customer-form' element={<CustomerSelfServicePage />} />
      <Route
        path='/dashboard/*'
        element={
          <ProtectedRoute>
            <MainApp />
          </ProtectedRoute>
        }
      />
      <Route path='/' element={<Navigate to='/dashboard' />} />
      <Route path='*' element={<Navigate to='/dashboard' />} />
    </Routes>
  );
}

/**
 * One bundle, two apps — the URL decides which one runs:
 *   https://apnicrm.com/admin   → Admin control panel (path based)
 *   https://admin.apnicrm.com/  → Admin control panel (dedicated subdomain)
 *   everything else             → Jewelry store CRM
 */
const BASE = process.env.PUBLIC_URL || '';

// Hosts that should always land straight on the admin console.
const ADMIN_HOSTS = ['admin.apnicrm.com'];
const isAdminHost = () => {
  const host = window.location.hostname.toLowerCase();
  return ADMIN_HOSTS.includes(host) || host.startsWith('admin.');
};

function App() {
  const atAdminPath =
    window.location.pathname === `${BASE}/admin` ||
    window.location.pathname.startsWith(`${BASE}/admin/`);
  const showAdmin = atAdminPath || isAdminHost();
  const basename = atAdminPath ? `${BASE}/admin` : BASE || '/';

  return (
    <>
      <ToastContainer position='bottom-right' theme='dark' />
      <Router basename={basename}>{showAdmin ? <AdminRoutes /> : <CrmRoutes />}</Router>
    </>
  );
}

export default App;
